import { faListCheck, faPlus } from "@fortawesome/free-solid-svg-icons";
import Page from "components/common/page/Page";
import ModalPortal from "components/modal/ModalPortal";
import { AppRoutes, URI_PARAMETER_KEYS } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";
import SaleNewItemModal from "./partial/SaleNewItemModal";
import SaleDatalist, { SaleDatalistPropsType } from "components/entities/agriculture/sale/SaleDatalist";
import { useParams } from "react-router-dom";
import If from "@/components/common/If";
import { uuid } from "@/config/app-constants";
import { DatalistFilterDefinitions } from "@/utilities/datalist/datalist-filter-utilities";

const SALE_NEW_MODAL_ID = 'new-sale';

const SaleDatalistPage = () => {
    const context = useAppContext();
    const {[URI_PARAMETER_KEYS.TARGET_SEASON_ID]: targetSeasonId} = useParams<{ [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: string }>();
    const pageActions = [
        {
            icon: faListCheck,
            hide: !context.userHasRole(Roles.AGRICULTURE_SALES_WRITE) || targetSeasonId ? true : false,
            link: AppRoutes.AGRICULTURE_OVERVIEW_SALE_MULTI_UPDATE,
            title: context.t('pages.agriculture.sale.multi-update'),
            name: 'multi-update'
        },
        {
            icon: faPlus,
            link: () => context.modal.open(SALE_NEW_MODAL_ID),
            hide: !context.userHasRole(Roles.AGRICULTURE_SALES_WRITE) || targetSeasonId ? true : false,
            name: 'add',
            title: context.t('button.add')
        }
    ]

    let fixedFilters: SaleDatalistPropsType['fixedFilters'] = undefined;
    let config: SaleDatalistPropsType['config'] = undefined;
    if (targetSeasonId && !isNaN(Number(targetSeasonId))) {
        fixedFilters = {
            seasonId: {
                eq: Number(targetSeasonId)
            }
        };
    } else {
        config = {
            dataSource: {
                filter: {
                    id: uuid(),
                    logic: 'and',
                    filters: [DatalistFilterDefinitions.seasonFilterDefinition(context)]
                }
            }
        }
    }

    return (
        <>
            <Page title="pages.agriculture.sale.list" wFull actions={pageActions}>
                <SaleDatalist hasBottomNavigation={true} fixedFilters={fixedFilters} config={config} />
            </Page>
            <If condition={!targetSeasonId}>
                <ModalPortal title="common.select" name={SALE_NEW_MODAL_ID}>
                    <SaleNewItemModal />
                </ModalPortal>
            </If>
        </>
    );
};

export default SaleDatalistPage;

